import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "antd";
import { Fade } from "react-awesome-reveal";
import Button from "../common/Button";
import SvgIcon from "../../../assets/img/blogImage.png";
import styles from "./ContentBlock.module.css";

const ContentBlock = ({
  icon,
  title,
  content,
  section,
  button,
  id,
  direction,
}) => {
  const navigate = useNavigate();
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <section className={styles.contentSection}>
      <Fade direction={direction} triggerOnce>
        <Row
          className={`${styles.styledRow} ${styles[direction]}`}
          justify="space-between"
          align="middle"
          id={id}
        >
          {/* Conditionally render columns based on the direction */}
          {direction === "left" ? (
            <>
              <Col lg={11} md={11} sm={12} xs={24}>
                <SvgIcon src={icon} width="100%" height="100%" />
              </Col>
              <Col lg={11} md={11} sm={12} xs={24}>
                <div className={styles.contentWrapper}>
                  <h1>{title}</h1>
                  <p className={styles.content}>{content}</p>
                  {button && (
                    <div className={styles.buttonWrapper}>
                      {button.map((item, index) => (
                        <Button
                          key={index}
                          color={item.color}
                          onClick={() => navigate(item.link)}
                        >
                          {item.title}
                        </Button>
                      ))}
                    </div>
                  )}
                  {section && (
                    <div className={styles.serviceWrapper}>
                      <Row justify="space-between">
                        {section.map((item, index) => (
                          <Col key={index} span={11}>
                            <SvgIcon
                              src={item.icon}
                              width="60px"
                              height="60px"
                            />
                            <h6 className={styles.minTitle}>{item.title}</h6>
                            <p className={styles.minPara}>{item.content}</p>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col lg={11} md={11} sm={12} xs={24}>
                <div className={styles.contentWrapper}>
                  <h1>{title}</h1>
                  <p className={styles.content}>{content}</p>
                  {button && (
                    <div className={styles.buttonWrapper}>
                      {button.map((item, index) => (
                        <Button
                          key={index}
                          color={item.color}
                          onClick={() => navigate(item.link)}
                        >
                          {item.title}
                        </Button>
                      ))}
                    </div>
                  )}
                  {section && (
                    <div className={styles.serviceWrapper}>
                      <Row justify="space-between">
                        {section.map((item, index) => (
                          <Col key={index} span={11}>
                            <SvgIcon
                              src={item.icon}
                              width="60px"
                              height="60px"
                            />
                            <h6 className={styles.minTitle}>{item.title}</h6>
                            <p className={styles.minPara}>{item.content}</p>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}
                </div>
              </Col>

              <Col lg={11} md={11} sm={12} xs={24}>
                <img
                  width="100%"
                  height="100%"
                  src={SvgIcon}
                  alt="Online Education"
                />
              </Col>
            </>
          )}
        </Row>
      </Fade>
    </section>
  );
};

export default ContentBlock;
